import { render, staticRenderFns } from "./huay-list-detail.vue?vue&type=template&id=01ac44fb&scoped=true&"
import script from "./huay-list-detail.vue?vue&type=script&lang=js&"
export * from "./huay-list-detail.vue?vue&type=script&lang=js&"
import style0 from "./huay-list-detail.vue?vue&type=style&index=0&id=01ac44fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac44fb",
  null
  
)

export default component.exports